export function getBrightness(color) {
	const rgb = parseInt(color.replace("#", ""), 16); // convert rrggbb to decimal
	const r = (rgb >> 16) & 0xff; // extract red
	const g = (rgb >> 8) & 0xff; // extract green
	const b = (rgb >> 0) & 0xff; // extract blue

	// Calculate brightness according to the formula: (299*R + 587*G + 114*B) / 1000
	return (299 * r + 587 * g + 114 * b) / 1000;
}
